(ns app.front.view.inspections.visit.result-detail
  (:require [app.domain.group.config.model :as config-model]
            [app.domain.inspection.model :as inspection-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.entity-edit :as ee]
            [app.front.ui.radio :as ui-radio]
            [app.front.view.workspace.subs :as ws-subs]
            [app.i18n.model :as i18n-model]
            [core.front.event :refer [<sub]]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::all-result-details
  :<- [::ws-subs/config-tuple]
  (fn [configs _]
    (->> (config-model/keep-as-set :group.config/inspection-visit-result-details configs)
         (filter du/is-active?))))

(rf/reg-sub ::result-details
  :<- [::all-result-details]
  :<- [:language]
  (fn [[result-details lang] [_ visit-result]]
    (when visit-result
      (->> result-details
           ((inspection-model/filter-applicable-reasons-fn false))
           (filter (fn [result-detail]
                     (-> result-detail :visit-result-detail/result (= visit-result))))
           (sort-by :visit-result-detail/names (i18n-model/localized-string-comparator lang))))))

(rf/reg-sub ::result-detail-label
  :<- [::entities/context]
  :<- [:language]
  (fn [[ctx lang] [_ result]]
    (-> (entities/find-entity ctx {:entity/type                      :entity.type/visit-result-detail-label
                                   :visit-result-detail-label/result result})
        :visit-result-detail-label/text
        (i18n-model/get-text-from-entities-or-map lang))))

(defn result-detail-picker [{:keys [visit-id tr visit-result set-value disabled?]}]
  (let [value (<sub [::ee/attr-value visit-id :inspection.visit/result-details])
        lang  (<sub [:language])]
    [:div.align-bottom.inline-block.mb-2.mr-2
     [ui-radio/radio
      {:values       (<sub [::result-details visit-result])
       :name         "result-detail"
       :label-text   (or (<sub [::result-detail-label visit-result])
                         (tr [:inspection.visit/result-detail]))
       :val->str     #(inspection-model/visit-result-detail-name % lang)
       :on-change    (comp (partial set-value :inspection.visit/result-details) hash-set :db/id)
       :value        (<sub [::entities/entity (first value)])
       :disabled     disabled?
       :required     true
       :allow-empty? false}]]))
